const SAVE = "SAVE_CATEGORIES";

export function save(data) {
    return {
        type: SAVE,
        payload: data
    }
}